import { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import api from '../api';

const Footer = (settings) => {
  const [metaData, setMetaData] = useState({});
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);
  const [message, setMessage] = useState("");
  const [notification, setNotification] = useState({ message: "", type: "" });

  const showNotification = (message, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 1000);
  };
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const footerData = [
    {
      title: "Terms and Conditions",
      links: [
        { label: "Terms and Conditions", path: "/terms-conditions" },
        { label: "Privacy Policy", path: "/privacy-policy" },
        { label: "Return Policy", path: "/return-policy" },
        { label: "Shipping Policy", path: "/shipping-policy" },
        // { label: "Warranty Policy", path: "/warranty-policy" },
        // { label: "Sitemap", path: "./sitemap.xml" },
      ],
    },
    {
      title: "Quick Links",
      links: [
        { label: "About Us", path: "/about-us" },
        // { label: "Why Us", path: "/why-us" },
        // { label: "Our Blogs", path: "/blogs" },
        { label: "FAQ", path: "/faqs" },
        // { label: "Career", path: "/career" },
        { label: "Blogs", path: "/blogs" },
        { label: "Contact Us", path: "/contact-us" },
      ],
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await api.post('/subscriber-add', { email });

      setMessage(response.data.message || "Something went wrong");
    } catch (err) {
      showNotification(err.response?.data?.message || "An error occurred. Please try again.", "error");
    } finally {
      setLoading(false); // 🔹 important: always reset spinner
    }
  };


  useEffect(() => {
    if (settings.setting && settings.setting.length > 0) {
      const meta = {};
      settings.setting.forEach((setting) => {
        if (setting.type === "footer_logo_path") {
          meta.footer_logo_path = setting.value;
        }
        if (setting.type === "payment_method_images") {
          meta.payment_method_images = setting.value;
        }
        if (setting.type === "website_name") {
          meta.website_name = setting.value;
        }
        if (setting.type === "frontend_copyright_text") {
          meta.frontend_copyright_text = setting.value;
        }
        if (setting.type === "about_us_description") {
          meta.about_us_description = setting.value;
        }
        if (setting.type === "facebook_link") {
          meta.facebook_link = setting.value;
        }
        if (setting.type === "twitter_link") {
          meta.twitter_link = setting.value;
        }
        if (setting.type === "instagram_link") {
          meta.instagram_link = setting.value;
        }
        if (setting.type === "linkedin_link") {
          meta.linkedin_link = setting.value;
        }
      });
      setMetaData(meta);
    }
  }, [settings]);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000); // 3 sec

      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      {notification.message && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}

      <footer className="main-footer">
        <div className="widgets-section">
          <div className="container-fluid">
            <div className="row align-items-center justify-content-center text-center">
              {/* Newsletter */}
              <div className="footer-column col-lg-8 col-md-12 col-sm-12 col-12 mb-1">
                <div className="footer-widget">
                  <div className="newsletter">
                    <p className="widget-title fw-600 text-uppercase">Subscribe to our newsletter</p>
                    <p className="widget-sub-title fw-600">Transform Your Space with Us—Subscribe for Weekly Ideas!</p>
                  </div>
                </div>
              </div>
              <div className="footer-column col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                <div className="footer-widget">
                  <div className="newsletter">
                    {message && (
                      <div className="fade-message" style={{ color: "white", marginBottom: "10px", fontWeight: "lighter" }}>
                        {message}
                      </div>
                    )}
                    <form className="newsletter-form" onSubmit={handleSubmit}>
                      <input
                        type="email"
                        name="EMAIL"
                        placeholder="ENTER EMAIL ADDRESS"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <button type="submit" className="theme-btn" disabled={loading}>
                        {loading ? (
                          <span>
                            <i className="fa fa-spinner fa-spin"></i> Adding...
                          </span>
                        ) : message && message.toLowerCase().includes("success") ? (
                          <span style={{ color: "white", fontWeight: "bold" }}>
                            <i className="fa fa-check"></i> Subscribed
                          </span>
                        ) : (
                          <span style={{ fontWeight: "bold" }}>
                            <i className="fa fa-envelope"></i> Subscribe
                          </span>
                        )}
                      </button>
                    </form>


                  </div>
                </div>
              </div>

            </div>

            <div className="row">

              {/* About Us */}
              <div className="footer-column col-lg-3 col-md-6 col-sm-12">
                <div className="footer-widget about-widget text-center">
                  <Link to="/">
                    <img className='footer-logo pb-3' src={metaData.footer_logo_path} alt={metaData.website_name} title="" />
                  </Link>
                  {metaData.about_us_description && (
                    <div
                      className="text"
                      dangerouslySetInnerHTML={{ __html: metaData.about_us_description }}
                    ></div>
                  )}

                  <ul
                    className="social-icon-two pt-2 navigation"
                    style={{ display: "flex", justifyContent: "center", gap: "8px", listStyle: "none", padding: 0, margin: 0 }}
                  >
                    {metaData.twitter_link && (
                      <li>
                        <Link to={metaData.twitter_link}>
                          <i className="fab fa-twitter"></i>
                        </Link>
                      </li>
                    )}
                    {metaData.instagram_link && (
                      <li>
                        <Link to={metaData.instagram_link}>
                          <i className="fab fa-instagram"></i>
                        </Link>
                      </li>
                    )}
                    {metaData.facebook_link && (
                      <li>
                        <Link to={metaData.facebook_link}>
                          <i className="fab fa-facebook"></i>
                        </Link>
                      </li>
                    )}
                    {metaData.linkedin_link && (
                      <li>
                        <Link to={metaData.linkedin_link}>
                          <i className="fab fa-linkedin-in"></i>
                        </Link>
                      </li>
                    )}
                  </ul>


                </div>
              </div>


              {/* We Accept */}
              <div className="footer-column col-lg-3 col-md-6 col-sm-12">
                <div className="footer-widget about-widget text-center">
                  <p className='widget-heading'>We accept:</p>
                  <Link to="#">
                    <img src="/images/icons/pay.png" alt={metaData.website_name} title="" />
                  </Link>
                </div>
              </div>

              {footerData.map((section, index) => (
                <div
                  key={index}
                  className={`footer-column d-none d-sm-flex col-lg-2 col-md-6 col-sm-12`}
                >
                  <div className="footer-widget">
                    <ul className="user-links navigation">
                      {section.links.map((link, linkIndex) => (
                        <li key={linkIndex}>
                          <Link to={link.path}>{link.label}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}

              <div className="faq-column mt-4 d-block d-sm-none">
                <div className="inner-column mb-md-50">
                  <ul className="accordion-box style-two bg-transparent p-0 navigation">
                    {footerData.map((section, index) => (
                      <li
                        className={`accordion block ${activeIndex === index ? 'active-block' : ''}`}
                        key={index}
                      >
                        <div
                          className={`text-white acc-btn ${activeIndex === index ? 'active' : ''}`}
                          onClick={() => toggleAccordion(index)}
                        >
                          <h5>{section.title}</h5>
                          <div className="icon fa fa-plus text-white"></div>
                        </div>
                        <div
                          className={`acc-content ${activeIndex === index ? 'current' : ''}`}
                          ref={(el) => (contentRefs.current[index] = el)}
                        >
                          <div className="content">
                            <ul className="user-links">
                              {section.links.map((link, linkIndex) => (
                                <li key={linkIndex}>
                                  {link.label === "Sitemap" ? (
                                    <a href={link.path} target="_blank" rel="noopener noreferrer">
                                      {link.label}
                                    </a>
                                  ) : (
                                    <Link to={link.path}>{link.label}</Link>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Contact */}
              <div className="footer-column col-lg-2 col-md-6 col-sm-12">
                <div className="footer-widget contact-widget">
                  <h5 className="widget-title">Get in Touch</h5>
                  <div className="widget-content">
                    <ul className="text navigation bBNav">
                      <li>For Customer Queries:</li>
                      <li><a className='text-light' href="mailto:contact@happyshells.in">contact@happyshells.in</a></li>
                      <li>For Bulk Orders:</li>
                      <li><a className='text-light' href="mailto:contact@happyshells.in">contact@happyshells.in</a></li>
                      <li>For PR/Marketing:</li>
                      <li><a className='text-light' href="mailto:info@happyshells.in">info@happyshells.in</a></li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="copyright">
          Copyright ©2024 happy Shells. Own &amp; Managed By{" "}
          <a href="https://happyshells.in" target="_blank" rel="noopener noreferrer">
            Sunil Trading Co.
          </a>{" "}
          All Rights Reserved.
          Designed by{" "}
          <a href="https://euonusit.com" target="_blank" rel="noopener noreferrer">
            Euonus It Pvt. Ltd.
          </a>
        </div>

      </footer>
    </>
  );
};

export default Footer;
